export interface Events {
  auth: {
    unauthenticated: {
      time: number
    }
    authenticated: string
  }
}

export type EventKey = {
  [Scope in keyof Events]: {
    [Name in keyof Events[Scope]]: `${Scope & string}:${Name & string}`
  }[keyof Events[Scope]]
}[keyof Events]

export type ExtractEventData<T extends EventKey> = T extends `${infer Scope}:${infer Name}`
  ? Scope extends keyof Events
    ? Name extends keyof Events[Scope]
      ? Events[Scope][Name]
      : never
    : never
  : never

export function creatEventManager() {
  return {
    on<CurrentEvent extends EventKey>(
      event: EventKey,
      callback: (payload?: ExtractEventData<CurrentEvent>) => void,
    ) {
      window.addEventListener(event, (e) => {
        const custom = e as CustomEvent<ExtractEventData<CurrentEvent>>
        callback(custom.detail)
      })

      return () => window.removeEventListener(event, callback as EventListener)
    },

    dispatch<CurrentEvent extends EventKey>(event: EventKey, payload?: ExtractEventData<CurrentEvent>) {
      window.dispatchEvent(new CustomEvent<CurrentEvent>(event, { detail: payload }))
    },
  }
}

export const eventsManager = creatEventManager()
